import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, RefreshCw, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, BACKEND_URL } from "@/lib/api";
import { SetupGuide } from "@/components/SetupGuide";
import { Metrics } from "@/components/Metrics";
import { HitsMonitor } from "@/components/HitsMonitor";

export const Overview = ({ settings, onChange }) => {
  const [stats, setStats] = useState(null);
  const url = settings ? `${BACKEND_URL}/api/webhook/${settings.webhook_token}` : "";

  useEffect(() => { api.get("/stats").then((r) => setStats(r.data)); }, []);

  const copy = async () => {
    await navigator.clipboard.writeText(url).catch(() => {});
    toast.success("URL copiada! Cole no campo Server URL do Auto Reply.");
  };
  const regenerate = async () => {
    if (!window.confirm("Gerar nova URL? A URL antiga deixará de funcionar.")) return;
    const r = await api.post("/settings/regenerate-token");
    onChange(r.data);
    toast.success("Nova URL gerada");
  };

  return (
    <div className="space-y-8">
      <section className="webhook-card" data-testid="webhook-card">
        <div className="flex items-center gap-2 text-[#10B981]">
          <Zap className="w-4 h-4" />
          <span className="mono-badge border-[#059669]/40">Sua URL de servidor próprio</span>
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mt-4 max-w-2xl">
          Uma URL. Painel IPTV e IA respondendo juntos.
        </h1>
        <p className="text-sm sm:text-base text-[#9CA3AF] mt-3 max-w-2xl">
          Substitua a URL do painel no Auto Reply por esta. Mensagens com comandos do painel continuam funcionando,
          e todo o resto é respondido pela IA.
        </p>
        <div className="url-box mt-6">
          <code className="font-mono text-xs sm:text-sm break-all text-[#F9FAFB]" data-testid="webhook-url">{url || "carregando..."}</code>
        </div>
        <div className="flex flex-wrap gap-3 mt-4">
          <Button onClick={copy} className="btn-primary h-12 px-6" data-testid="copy-webhook-button"><Copy className="w-4 h-4 mr-2" />Copiar URL</Button>
          <Button onClick={regenerate} variant="outline" className="btn-ghost h-12" data-testid="regenerate-token-button"><RefreshCw className="w-4 h-4 mr-2" />Gerar nova URL</Button>
        </div>
      </section>
      <Metrics stats={stats} />
      <HitsMonitor />
      <SetupGuide />
    </div>
  );
};
